'use client';

import { Suspense } from 'react';

import { usePathname } from 'next/navigation';

import { findCapabilityByPath } from '../_lib/capabilities';
import { HubSubtabs } from './HubSubtabs';
import { ZoneTabs } from './ZoneTabs';

/**
 * NIVEL 3 — route-dependent sub-bar, rendered below the always-visible
 * NIVEL 2 capability bar (`CapabilityBar`):
 *   `/`           → Hub subtabs (Today / Growth / Project)
 *   `/composer`   → none (Mundo B — Hunter is the protagonist, no zones)
 *   capability/*  → zone tabs + [← Back to Hub]
 *   other         → none
 */
export function SubBar() {
  const pathname = usePathname() ?? '/';

  if (pathname === '/') {
    return (
      <Suspense fallback={<div className="hub-subtabs-divider" style={{ height: 56 }} />}>
        <HubSubtabs />
      </Suspense>
    );
  }

  if (pathname === '/composer' || pathname.startsWith('/composer/')) {
    return null;
  }

  const capability = findCapabilityByPath(pathname);
  if (capability) return <ZoneTabs capability={capability} />;

  return null;
}
